module.exports = "https://beta.voredev.ru/assets/index/eye-red-bc19efabaa2006a0c049538571f242ac.svg";